import * as types from '../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";

export function loadParkMachineCategoriesSuccess(parkMachines) {
    return {type: types.LOAD_PARK_MACHINES_SUCCESS, parkMachines};
}

export function createParkMachineSuccess(parkMachine) {
    return {type: types.CREATE_PARK_MACHINE_SUCCESS, parkMachine};
}

export function getParkMachineSuccess(parkMachine) {
    return {type: types.GET_PARK_MACHINE_SUCCESS, parkMachine};
}

export function updateUpdateParkMachineSuccess(parkMachine) {
    return {type: types.UPDATE_PARK_MACHINE_SUCCESS, parkMachine};
}

export function deleteParkMachineSuccess(id) {
    return {type: types.DELETE_PARK_MACHINE_SUCCESS, id};
}

export function resetParkMachine() {
    return { type: types.RESET_PARK_MACHINE };
}

export function getParkMachine(id) {
    return function (dispatch) {
        return PrivateAPIResource
            .get('park-machines/' + id)
            .then(parkMachine => {
                dispatch(getParkMachineSuccess(parkMachine))
            }).catch(error => {
                throw error;
            });
    }
}

export function getParkMachines(page, sortParams) {
    return function (dispatch) {
        return PrivateAPIResource
            .get('park-machines?page='+page, null, sortParams)
            .then(parkMachines => {
                dispatch(loadParkMachineCategoriesSuccess(parkMachines))
            }).catch(error => {
                throw error;
            });
    }
}

export function saveParkMachine(parkMachine) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .create('park-machine/create', parkMachine, true)
            .then(parkMachine => {
                dispatch(createParkMachineSuccess(parkMachine));
            })
            .catch(error => {
                throw error;
            });
    }
}

export function updateParkMachine(parkMachine, id) {
    return function (dispatch, getState) {
        return PrivateAPIResource
            .update('park-machine/update', id, parkMachine)
            .then(parkMachine => {
                dispatch(updateUpdateParkMachineSuccess(parkMachine));
            })
            .catch(error => {
                throw error;
            })
    }
}

export function deleteParkMachine(id) {
    return function (dispatch) {
        return PrivateAPIResource
            .remove('park-machine/remove', id)
            .then(() => {
                dispatch(deleteParkMachineSuccess(id));
            })
            .catch(error => {
                throw error;
            });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/park-machine/parkMachineActions.js